import React, { useState } from 'react';
import BeneficiaryDetails from 'components/BeneficiaryDetails';
import { Loader } from 'components/Loader';
import BankAsset from 'components/Cards/AssetsCards/BankAsset';
import { useParams } from 'react-router-dom';
import { useGetCustomerBankList } from 'common/queries-and-mutations/admin/customer';

export default function BankBeneficiaries() {
  const [selectedAssetId, setSelectedAssetId] = useState<number | undefined>(
    undefined
  );
  const { customerId } = useParams();

  const { data, isLoading: isBankLoading } = useGetCustomerBankList({
    customerId: +customerId!
  });

  const handleShowDetails = (assetId: number) => {
    setSelectedAssetId(selectedAssetId === assetId ? undefined : assetId);
  };

  return (
    <div className="rounded-md bg-white shadow-sm">
      {isBankLoading ? (
        <div className="mt-40 flex flex-col items-center justify-center">
          <Loader color={'#FF6606'} height={50} width={50} />
        </div>
      ) : (
        <>
          {data?.map(bank => {
            return (
              <div className="mb-4 w-full border-b" key={bank.id}>
                <BankAsset
                  bank={bank}
                  selectedAssetId={selectedAssetId}
                  handleShowDetails={() => handleShowDetails(bank.id!)}
                />
                {selectedAssetId === bank.id && (
                  <div className="mt-2 border-t">
                    {bank.totalBeneficiary > 0 ? (
                      <>
                        <p className="px-6 py-5 text-base font-semibold text-[#34475E]">
                          Beneficiaries
                        </p>
                        <div className="px-3 pb-6">
                          {bank.totalBeneficiary > 0
                            ? bank.allocations.map(allocation => (
                                <BeneficiaryDetails
                                  key={allocation.id}
                                  allocation={allocation}
                                />
                              ))
                            : null}
                        </div>
                      </>
                    ) : (
                      <div className="flex items-center justify-center py-32 font-circular text-[#34475E]">
                        No Beneficiary Assigned
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </>
      )}
    </div>
  );
}
